import { buildUrl, filterEmpty } from ".";
const { getGlobal } = useGlobal();
export default function sendErrMsg() {
  const errMsg = getGlobal("errMsg");
  const params = filterEmpty({
    host: window.location.hostname,
    msg: errMsg,
  });
  const url = buildUrl(import.meta.env.VITE_LOG_URL3, params);
  fetch(url, { method: "GET" });
}
